import React from 'react';
import { Lock, MessageCircle, LogOut, Sparkles } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const LockedDashboard: React.FC = () => {
    const { signOut, user } = useAuth();

    const handleWhatsAppSupport = () => {
        // Pre-filled message for beta access request
        const message = 'Hello, I\'d like to request access to the beta testing program.';
        window.open(`https://wa.me/966550323049?text=${encodeURIComponent(message)}`, '_blank');
    };

    return (
        <div className="min-h-screen bg-black flex flex-col items-center justify-center p-4 relative overflow-hidden">
            {/* Background Effects */}
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-red-900/10 rounded-full blur-[120px]"></div>
            </div>

            <div className="max-w-md w-full bg-zinc-900/50 border border-zinc-800 backdrop-blur-xl rounded-2xl p-8 flex flex-col items-center text-center space-y-6 relative z-10 shadow-2xl">
                {/* Icon */}
                <div className="p-4 bg-yellow-500/10 rounded-full border border-yellow-500/20 shadow-[0_0_30px_rgba(234,179,8,0.2)]">
                    <Sparkles size={40} className="text-yellow-500" />
                </div>

                {/* Title & Description */}
                <div className="space-y-4">
                    <h1 className="text-3xl font-bold text-white tracking-tight">Beta Testing Access</h1>
                    <div className="space-y-2">
                        <p className="text-zinc-300 text-sm leading-relaxed">
                            Thank you for your interest! We're currently in <span className="text-yellow-500 font-medium">exclusive beta testing</span>.
                        </p>
                        <p className="text-zinc-400 text-sm">
                            Access is granted by invitation. Contact us on WhatsApp to request access and we'll get you started.
                        </p>
                    </div>
                </div>

                <div className="w-full h-px bg-zinc-800" />

                {/* Action Buttons */}
                <div className="w-full space-y-3">
                    {/* Primary: WhatsApp Contact */}
                    <button
                        onClick={handleWhatsAppSupport}
                        className="w-full py-3 bg-gradient-to-r from-yellow-600 to-yellow-500 hover:from-yellow-500 hover:to-yellow-400 text-black rounded-xl font-bold transition-all shadow-lg hover:shadow-yellow-500/20 flex items-center justify-center gap-2"
                    >
                        <MessageCircle size={18} className="text-green-600" />
                        <span>Request Beta Access</span>
                    </button>

                    {/* Secondary: Sign Out */}
                    <button
                        onClick={() => signOut()}
                        className="w-full py-3 bg-transparent hover:bg-zinc-800/50 text-zinc-500 hover:text-zinc-300 rounded-xl font-medium transition-all flex items-center justify-center gap-2 text-sm"
                    >
                        <LogOut size={16} />
                        <span>Sign Out</span>
                    </button>
                </div>

                {/* Beta Badge */}
                <div className="pt-4">
                    <div className="inline-flex items-center gap-2 px-4 py-2 bg-yellow-500/10 border border-yellow-500/20 rounded-full">
                        <span className="relative flex h-2 w-2">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-yellow-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-2 w-2 bg-yellow-500"></span>
                        </span>
                        <span className="text-xs text-yellow-500 font-medium">Limited Beta</span>
                    </div>
                </div>
            </div>

            <p className="absolute bottom-8 text-zinc-600 text-xs text-center">
                Nano Banana Engine &copy; {new Date().getFullYear()}
            </p>
        </div>
    );
};

export default LockedDashboard;
